"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer() {
  return _react2.default.createElement("a", { href: "http://lesalt.cn/", className: "logo", target: "_blank" });
};

exports.default = Footer;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/_rs-page@0.0.3@rs-page/lib/components/Footer.js
// module id = 1911
// module chunks = 0